import {init as initApm} from '@elastic/apm-rum';
import Environments from "js/constants/environments";

const APM_SERVER_URL = Object.freeze({
    NON_PROD: 'https://apm-int-ause.solutions.corelogic.com',
    PROD: 'https://apm-ause.solutions.corelogic.com',
})

const ENVIRONMENTS = {
    [Environments.DEVELOPMENT]: 'dev',
    [Environments.DEV_LOCAL]: 'dev',
    [Environments.UAT]: 'uat',
    [Environments.PROD]: 'prd',
};

const APP_NAME = window.ENV.COUNTRY_CODE === 'au' ? 'crux-ui-au' : 'crux-ui-nz';

const apm = initApm({
    serviceName: APP_NAME,
    serverUrl: window.ENV.APP_ENV === Environments.prod
        ? APM_SERVER_URL.PROD
        : APM_SERVER_URL.NON_PROD,
    environment: ENVIRONMENTS[window.ENV.APP_ENV],
    breakdownMetrics: true,
});

apm.addLabels({
    organization: 'real_estate_aus',
    space: 'prp_rp_data',
    application: APP_NAME,
    environment: ENVIRONMENTS[window.ENV.APP_ENV],
});

export default apm;